import { Api as api } from "../api";
const prefix = "/config";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    distanceTypeServiceV1ListDistanceTypes: build.query<
      DistanceTypeServiceV1ListDistanceTypesApiResponse,
      DistanceTypeServiceV1ListDistanceTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/distance-types`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort: queryArg.sort,
          order: queryArg.order,
          status: queryArg.status,
          distance_type_name: queryArg.distanceTypeName,
          distance_condition: queryArg.distanceCondition,
          description: queryArg.description,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
          distance: queryArg.distance,
        },
      }),
    }),
    distanceTypeServiceV1BatchCreateDistanceType: build.mutation<
      DistanceTypeServiceV1BatchCreateDistanceTypeApiResponse,
      DistanceTypeServiceV1BatchCreateDistanceTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/distance-types`,
        method: "POST",
        body: queryArg.distanceTypeV1BatchCreateDistanceTypeReq,
      }),
    }),
    distanceTypeServiceV1ActivateDistanceTypes: build.mutation<
      DistanceTypeServiceV1ActivateDistanceTypesApiResponse,
      DistanceTypeServiceV1ActivateDistanceTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/distance-types/activate`,
        method: "PATCH",
        body: queryArg.distanceTypeV1DistanceTypeBulkStatusChangeReq,
      }),
    }),
    distanceTypeServiceV1DeactivateDistanceTypes: build.mutation<
      DistanceTypeServiceV1DeactivateDistanceTypesApiResponse,
      DistanceTypeServiceV1DeactivateDistanceTypesApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/distance-types/deactivate`,
        method: "PATCH",
        body: queryArg.distanceTypeV1DistanceTypeBulkStatusChangeReq,
      }),
    }),
    distanceTypeServiceV1GetDistanceTypeDropdown: build.query<
      DistanceTypeServiceV1GetDistanceTypeDropdownApiResponse,
      DistanceTypeServiceV1GetDistanceTypeDropdownApiArg
    >({
      query: () => ({ url: `${prefix}/v1/distance-types/dropdown` }),
    }),
    distanceTypeServiceV1GetDistanceType: build.query<
      DistanceTypeServiceV1GetDistanceTypeApiResponse,
      DistanceTypeServiceV1GetDistanceTypeApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/distance-types/${queryArg.id}` }),
    }),
    distanceTypeServiceV1UpdateDistanceType: build.mutation<
      DistanceTypeServiceV1UpdateDistanceTypeApiResponse,
      DistanceTypeServiceV1UpdateDistanceTypeApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/distance-types/${queryArg.id}`,
        method: "PUT",
        body: queryArg.distanceTypeServiceV1UpdateDistanceTypeBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as distanceTypeApi };
export type DistanceTypeServiceV1ListDistanceTypesApiResponse =
  /** status 200 A successful response. */ DistanceTypeV1ListDistanceTypesRes;
export type DistanceTypeServiceV1ListDistanceTypesApiArg = {
  page?: number;
  size?: number;
  sort?: string;
  order?: string;
  status?: string;
  distanceTypeName?: string;
  distanceCondition?: string;
  description?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
  distance?: string;
};
export type DistanceTypeServiceV1BatchCreateDistanceTypeApiResponse =
  /** status 200 A successful response. */ DistanceTypeV1BatchCreateDistanceTypeRes;
export type DistanceTypeServiceV1BatchCreateDistanceTypeApiArg = {
  distanceTypeV1BatchCreateDistanceTypeReq: DistanceTypeV1BatchCreateDistanceTypeReq;
};
export type DistanceTypeServiceV1ActivateDistanceTypesApiResponse =
  /** status 200 A successful response. */ DistanceTypeV1DistanceTypeBulkStatusChangeRes;
export type DistanceTypeServiceV1ActivateDistanceTypesApiArg = {
  distanceTypeV1DistanceTypeBulkStatusChangeReq: DistanceTypeV1DistanceTypeBulkStatusChangeReq;
};
export type DistanceTypeServiceV1DeactivateDistanceTypesApiResponse =
  /** status 200 A successful response. */ DistanceTypeV1DistanceTypeBulkStatusChangeRes;
export type DistanceTypeServiceV1DeactivateDistanceTypesApiArg = {
  distanceTypeV1DistanceTypeBulkStatusChangeReq: DistanceTypeV1DistanceTypeBulkStatusChangeReq;
};
export type DistanceTypeServiceV1GetDistanceTypeDropdownApiResponse =
  /** status 200 A successful response. */ DistanceTypeV1GetDistanceTypeDropdownRes;
export type DistanceTypeServiceV1GetDistanceTypeDropdownApiArg = void;
export type DistanceTypeServiceV1GetDistanceTypeApiResponse =
  /** status 200 A successful response. */ DistanceTypeV1DistanceTypeDetailRes;
export type DistanceTypeServiceV1GetDistanceTypeApiArg = {
  id: string;
};
export type DistanceTypeServiceV1UpdateDistanceTypeApiResponse =
  /** status 200 A successful response. */ DistanceTypeV1DistanceTypeMessageRes;
export type DistanceTypeServiceV1UpdateDistanceTypeApiArg = {
  id: string;
  distanceTypeServiceV1UpdateDistanceTypeBody: DistanceTypeServiceV1UpdateDistanceTypeBody;
};
export type DistanceTypeV1DistanceTypeRes = {
  id?: string;
  distance_type_name?: string;
  distance_condition?: string;
  distance_min?: number;
  distance_max?: number;
  distance?: string;
  description?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type DistanceTypeV1DistanceTypePaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type DistanceTypeV1ListDistanceTypesRes = {
  distance_types?: DistanceTypeV1DistanceTypeRes[];
  metadata?: DistanceTypeV1DistanceTypePaginationMeta;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type DistanceTypeV1BatchCreateDistanceTypeResData = {
  created_count?: number;
  ids?: string[];
};
export type DistanceTypeV1BatchCreateDistanceTypeRes = {
  message?: string;
  data?: DistanceTypeV1BatchCreateDistanceTypeResData;
};
export type DistanceTypeV1CreateDistanceTypeItem = {
  distance_type_name: string;
  distance_condition: string;
  distance_min?: number;
  distance_max?: number;
  description?: string;
  status: string;
};
export type DistanceTypeV1BatchCreateDistanceTypeReq = {
  distance_types: DistanceTypeV1CreateDistanceTypeItem[];
};
export type DistanceTypeV1DistanceTypeBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type DistanceTypeV1DistanceTypeBulkStatusChangeReq = {
  ids: string[];
};
export type DistanceTypeV1DistanceTypeDropdownItem = {
  id?: string;
  distance_type_name?: string;
};
export type DistanceTypeV1GetDistanceTypeDropdownRes = {
  distance_types?: DistanceTypeV1DistanceTypeDropdownItem[];
};
export type DistanceTypeV1DistanceTypeDetailRes = {
  id?: string;
  distance_type_name?: string;
  distance_condition?: string;
  distance_min?: number;
  distance_max?: number;
  distance?: string;
  description?: string;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type DistanceTypeV1DistanceTypeMessageRes = {
  message?: string;
};
export type DistanceTypeServiceV1UpdateDistanceTypeBody = {
  distance_type_name: string;
  distance_condition: string;
  distance_min?: number;
  distance_max?: number;
  description?: string;
};
export const {
  useDistanceTypeServiceV1ListDistanceTypesQuery,
  useDistanceTypeServiceV1BatchCreateDistanceTypeMutation,
  useDistanceTypeServiceV1ActivateDistanceTypesMutation,
  useDistanceTypeServiceV1DeactivateDistanceTypesMutation,
  useDistanceTypeServiceV1GetDistanceTypeDropdownQuery,
  useDistanceTypeServiceV1GetDistanceTypeQuery,
  useDistanceTypeServiceV1UpdateDistanceTypeMutation,
} = injectedRtkApi;
